import { makeStyles } from '@mui/styles';

export const useActionButtonSingleStyles = makeStyles({
  button: {
    paddingTop: '5px',
    paddingBottom: '5px',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '5px',
    padding: '3px 12px',
    whiteSpace: 'nowrap',
    height: '40px'
  }
});
